/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type SetMineOnlineStatusMutationVariables = Exact<{
  isOnline: boolean;
}>;

export type SetMineOnlineStatusMutation = {
  updateMineOnlineState: { status: boolean | null } | null;
};

export type MineStatusQueryVariables = Exact<{ [key: string]: never }>;

export type MineStatusQuery = {
  mineStatus: { online: boolean | null; mineStatusId: string | null } | null;
};

export type SupportThreadDetailsFragment = {
  supportRequestId: string | null;
  version: Types.SupportSystemVersion | null;
  isAnswered: boolean | null;
  isSolved: boolean | null;
  currentSupportManagerId: string | null;
  lastMessage: string | null;
  lastMessageDate: number | null;
  organizationId: string | null;
  supportTeamId: string | null;
  supportedUserId: string | null;
  context: Types.ZalamoSupportContext | null;
  ownerState: Types.SupportOwnerState | null;
  isRead: boolean | null;
  conversationId: string | null;
  isSeenByClient: boolean | null;
  studio: {
    organizationId: string;
    name: string | null;
    zalamoPayConfigFinished: boolean | null;
    zalamoPayRegisterInProgress: boolean | null;
  } | null;
  mobileDevice: {
    deviceId: string;
    summaryLabel: string;
    isLoggedIn: boolean;
    platform: string | null;
    model: string | null;
    version: string | null;
    language: string | null;
    pushAvailable: boolean;
    notificationsAuthorized: boolean | null;
    firstSeenAt: string | null;
    updatedAt: string | null;
    currentUser: {
      userId: string;
      displayName: string | null;
      email: string | null;
      isActive: boolean;
      firstLinkedAt: string | null;
      lastLinkedAt: string | null;
    } | null;
    linkedUsers: Array<{
      userId: string;
      displayName: string | null;
      email: string | null;
      isActive: boolean;
      firstLinkedAt: string | null;
      lastLinkedAt: string | null;
    }>;
    visitedPublicSessions: Array<{
      hash: string | null;
      signupId: string | null;
      childId: string | null;
      orderId: string | null;
      lastVisitedAt: string;
    }>;
    visitedSignups: Array<{
      hash: string | null;
      signupId: string | null;
      childId: string | null;
      orderId: string | null;
      lastVisitedAt: string;
    }>;
    visitedOrders: Array<{
      hash: string | null;
      signupId: string | null;
      childId: string | null;
      orderId: string | null;
      lastVisitedAt: string;
    }>;
  } | null;
  mobileDevices: Array<{
    deviceId: string;
    summaryLabel: string;
    isLoggedIn: boolean;
    platform: string | null;
    model: string | null;
    version: string | null;
    language: string | null;
    pushAvailable: boolean;
    notificationsAuthorized: boolean | null;
    firstSeenAt: string | null;
    updatedAt: string | null;
    currentUser: {
      userId: string;
      displayName: string | null;
      email: string | null;
      isActive: boolean;
      firstLinkedAt: string | null;
      lastLinkedAt: string | null;
    } | null;
    linkedUsers: Array<{
      userId: string;
      displayName: string | null;
      email: string | null;
      isActive: boolean;
      firstLinkedAt: string | null;
      lastLinkedAt: string | null;
    }>;
    visitedPublicSessions: Array<{
      hash: string | null;
      signupId: string | null;
      childId: string | null;
      orderId: string | null;
      lastVisitedAt: string;
    }>;
    visitedSignups: Array<{
      hash: string | null;
      signupId: string | null;
      childId: string | null;
      orderId: string | null;
      lastVisitedAt: string;
    }>;
    visitedOrders: Array<{
      hash: string | null;
      signupId: string | null;
      childId: string | null;
      orderId: string | null;
      lastVisitedAt: string;
    }>;
  }>;
};

export type SupportMobileDeviceDetailsFragment = {
  deviceId: string;
  summaryLabel: string;
  isLoggedIn: boolean;
  platform: string | null;
  model: string | null;
  version: string | null;
  language: string | null;
  pushAvailable: boolean;
  notificationsAuthorized: boolean | null;
  firstSeenAt: string | null;
  updatedAt: string | null;
  currentUser: {
    userId: string;
    displayName: string | null;
    email: string | null;
    isActive: boolean;
    firstLinkedAt: string | null;
    lastLinkedAt: string | null;
  } | null;
  linkedUsers: Array<{
    userId: string;
    displayName: string | null;
    email: string | null;
    isActive: boolean;
    firstLinkedAt: string | null;
    lastLinkedAt: string | null;
  }>;
  visitedPublicSessions: Array<{
    hash: string | null;
    signupId: string | null;
    childId: string | null;
    orderId: string | null;
    lastVisitedAt: string;
  }>;
  visitedSignups: Array<{
    hash: string | null;
    signupId: string | null;
    childId: string | null;
    orderId: string | null;
    lastVisitedAt: string;
  }>;
  visitedOrders: Array<{
    hash: string | null;
    signupId: string | null;
    childId: string | null;
    orderId: string | null;
    lastVisitedAt: string;
  }>;
};

export type SupportMobileDeviceUserDetailsFragment = {
  userId: string;
  displayName: string | null;
  email: string | null;
  isActive: boolean;
  firstLinkedAt: string | null;
  lastLinkedAt: string | null;
};

export type SupportMobileDeviceVisitDetailsFragment = {
  hash: string | null;
  signupId: string | null;
  childId: string | null;
  orderId: string | null;
  lastVisitedAt: string;
};

export type SupportIssueDetailsFragment = {
  issueId: string;
  version: number;
  organizationId: string;
  supportTeamId: string;
  title: string;
  description: string | null;
  status: Types.SupportIssueStatus;
  allowedStatusTransitions: Array<Types.SupportIssueStatus>;
  priority: Types.SupportIssuePriority;
  deadlineDate: string | null;
  assigneeUserId: string | null;
  reporterUserId: string;
  sourceType: Types.SupportIssueSourceType;
  sourceSupportThreadId: string | null;
  sourceConversationId: string | null;
  sourceContext: string | null;
  sourceContextId: string | null;
  supportedUserId: string | null;
  messageSummary: string | null;
  tags: Array<string>;
  createdAt: number;
  updatedAt: number;
  triagedAt: number | null;
  triagedBy: string | null;
  nextActionType: Types.SupportIssueNextActionType | null;
  nextActionAt: number | null;
  nextActionOwnerUserId: string | null;
  nextActionNote: string | null;
  resolutionCode: Types.SupportIssueResolutionCode | null;
  resolutionSummary: string | null;
  resolvedBy: string | null;
  lastReopenReason: string | null;
  reopenCount: number;
  lastReopenedAt: number | null;
  lastReopenedBy: string | null;
  closedAt: number | null;
  extractedLinks: Array<{
    url: string;
    domain: string | null;
    kind: string | null;
    label: string | null;
    firstSeenAt: number | null;
    firstSeenMessageId: string | null;
  }>;
  customerSnapshot: {
    userId: string | null;
    displayName: string | null;
    email: string | null;
    phone: string | null;
    verifiedPhone: boolean | null;
    type: Array<Types.OldUserType | null> | null;
    clientSessionsCount: number | null;
    photographerPrivateSessionsCount: number | null;
    photographerPublicSessionsCount: number | null;
    photographerAlbumDesignCount: number | null;
    photographerWeddingCount: number | null;
    photographerGalleryCount: number | null;
    photographerBookingsCount: number | null;
    sessions: Array<{
      name: string | null;
      oldSessionDetailsId: string | null;
      created: number | null;
      photographer: {
        userId: string | null;
        name: string | null;
        login: string | null;
        phone: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetProductsForProofingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetProductsForProofingQuery = {
  getProductsForProofing: Array<{
    pagesCount: number | null;
    productForProofingId: string | null;
    sourceProductInOrderId: string | null;
    sourceProjectId: string | null;
    sourceProjectUserId: string | null;
    productForProofingType: Types.ProductForProofingType | null;
    pages: Array<{
      pageId: string | null;
      sourcePhotoId: string | null;
      label: string | null;
      blobName: string | null;
      blobRotation: number | null;
      blobClip: Array<number | null> | null;
      tabloProjectId: string | null;
      organizationId: string | null;
      blobTargetPosition: { x: number | null; y: number | null } | null;
      blobTargetSize: { width: number | null; height: number | null } | null;
      canvasTargetSize: { width: number | null; height: number | null } | null;
    } | null> | null;
  } | null> | null;
};

export type MarkProductAsProofedMutationVariables = Exact<{
  productForProofingId: string;
}>;

export type MarkProductAsProofedMutation = {
  markProductAsProofed: { status: boolean | null } | null;
};

export type MarkProductAsBrokenMutationVariables = Exact<{
  productForProofingId: string;
}>;

export type MarkProductAsBrokenMutation = {
  markProductAsBroken: { status: boolean | null } | null;
};

export type RefreshTabloProofingRenderMutationVariables = Exact<{
  productForProofingId: string;
}>;

export type RefreshTabloProofingRenderMutation = {
  refreshTabloProofingRender: { status: boolean | null } | null;
};

export type SupportThreadsQueryVariables = Exact<{
  state: Types.SupportOwnerState;
}>;

export type SupportThreadsQuery = {
  currentSupportRequests: {
    supportRequestListId: string | null;
    requests: Array<{
      supportRequestId: string | null;
      version: Types.SupportSystemVersion | null;
      isAnswered: boolean | null;
      isSolved: boolean | null;
      currentSupportManagerId: string | null;
      lastMessage: string | null;
      lastMessageDate: number | null;
      organizationId: string | null;
      supportTeamId: string | null;
      supportedUserId: string | null;
      context: Types.ZalamoSupportContext | null;
      ownerState: Types.SupportOwnerState | null;
      isRead: boolean | null;
      conversationId: string | null;
      isSeenByClient: boolean | null;
      studio: {
        organizationId: string;
        name: string | null;
        zalamoPayConfigFinished: boolean | null;
        zalamoPayRegisterInProgress: boolean | null;
      } | null;
      mobileDevice: {
        deviceId: string;
        summaryLabel: string;
        isLoggedIn: boolean;
        platform: string | null;
        model: string | null;
        version: string | null;
        language: string | null;
        pushAvailable: boolean;
        notificationsAuthorized: boolean | null;
        firstSeenAt: string | null;
        updatedAt: string | null;
        currentUser: {
          userId: string;
          displayName: string | null;
          email: string | null;
          isActive: boolean;
          firstLinkedAt: string | null;
          lastLinkedAt: string | null;
        } | null;
        linkedUsers: Array<{
          userId: string;
          displayName: string | null;
          email: string | null;
          isActive: boolean;
          firstLinkedAt: string | null;
          lastLinkedAt: string | null;
        }>;
        visitedPublicSessions: Array<{
          hash: string | null;
          signupId: string | null;
          childId: string | null;
          orderId: string | null;
          lastVisitedAt: string;
        }>;
        visitedSignups: Array<{
          hash: string | null;
          signupId: string | null;
          childId: string | null;
          orderId: string | null;
          lastVisitedAt: string;
        }>;
        visitedOrders: Array<{
          hash: string | null;
          signupId: string | null;
          childId: string | null;
          orderId: string | null;
          lastVisitedAt: string;
        }>;
      } | null;
      mobileDevices: Array<{
        deviceId: string;
        summaryLabel: string;
        isLoggedIn: boolean;
        platform: string | null;
        model: string | null;
        version: string | null;
        language: string | null;
        pushAvailable: boolean;
        notificationsAuthorized: boolean | null;
        firstSeenAt: string | null;
        updatedAt: string | null;
        currentUser: {
          userId: string;
          displayName: string | null;
          email: string | null;
          isActive: boolean;
          firstLinkedAt: string | null;
          lastLinkedAt: string | null;
        } | null;
        linkedUsers: Array<{
          userId: string;
          displayName: string | null;
          email: string | null;
          isActive: boolean;
          firstLinkedAt: string | null;
          lastLinkedAt: string | null;
        }>;
        visitedPublicSessions: Array<{
          hash: string | null;
          signupId: string | null;
          childId: string | null;
          orderId: string | null;
          lastVisitedAt: string;
        }>;
        visitedSignups: Array<{
          hash: string | null;
          signupId: string | null;
          childId: string | null;
          orderId: string | null;
          lastVisitedAt: string;
        }>;
        visitedOrders: Array<{
          hash: string | null;
          signupId: string | null;
          childId: string | null;
          orderId: string | null;
          lastVisitedAt: string;
        }>;
      }>;
    } | null> | null;
  } | null;
};

export type GetDisplayNameQueryVariables = Exact<{
  userId: string;
}>;

export type GetDisplayNameQuery = { getDisplayNameForUserId: string | null };

export type GetSupportThreadDetailsQueryVariables = Exact<{
  supportThreadId: string;
}>;

export type GetSupportThreadDetailsQuery = {
  getSupportThreadIdDetails: {
    supportRequestId: string | null;
    version: Types.SupportSystemVersion | null;
    isAnswered: boolean | null;
    isSolved: boolean | null;
    currentSupportManagerId: string | null;
    lastMessage: string | null;
    lastMessageDate: number | null;
    organizationId: string | null;
    supportTeamId: string | null;
    supportedUserId: string | null;
    context: Types.ZalamoSupportContext | null;
    ownerState: Types.SupportOwnerState | null;
    isRead: boolean | null;
    conversationId: string | null;
    isSeenByClient: boolean | null;
    studio: {
      organizationId: string;
      name: string | null;
      zalamoPayConfigFinished: boolean | null;
      zalamoPayRegisterInProgress: boolean | null;
    } | null;
    mobileDevice: {
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    } | null;
    mobileDevices: Array<{
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    }>;
  } | null;
};

export type SupportIssueThreadListItemFragment = {
  issueId: string;
  title: string;
  status: Types.SupportIssueStatus;
  priority: Types.SupportIssuePriority;
  deadlineDate: string | null;
  assigneeUserId: string | null;
  nextActionType: Types.SupportIssueNextActionType | null;
  nextActionAt: number | null;
  nextActionOwnerUserId: string | null;
  nextActionNote: string | null;
  updatedAt: number;
};

export type GetSupportIssuesQueryVariables = Exact<{
  sourceSupportThreadId?: string | null | undefined;
  organizationId?: string | null | undefined;
  assigneeUserId?: string | null | undefined;
  status?:
    | Array<Types.SupportIssueStatus>
    | Types.SupportIssueStatus
    | null
    | undefined;
}>;

export type GetSupportIssuesQuery = {
  getSupportIssues: Array<{
    issueId: string;
    title: string;
    status: Types.SupportIssueStatus;
    priority: Types.SupportIssuePriority;
    deadlineDate: string | null;
    assigneeUserId: string | null;
    nextActionType: Types.SupportIssueNextActionType | null;
    nextActionAt: number | null;
    nextActionOwnerUserId: string | null;
    nextActionNote: string | null;
    updatedAt: number;
  }>;
};

export type SupportIssueBoardListItemFragment = {
  issueId: string;
  version: number;
  organizationId: string;
  supportTeamId: string;
  title: string;
  status: Types.SupportIssueStatus;
  priority: Types.SupportIssuePriority;
  deadlineDate: string | null;
  assigneeUserId: string | null;
  sourceType: Types.SupportIssueSourceType;
  sourceSupportThreadId: string | null;
  sourceConversationId: string | null;
  sourceContext: string | null;
  tags: Array<string>;
  createdAt: number;
  updatedAt: number;
  nextActionType: Types.SupportIssueNextActionType | null;
  nextActionAt: number | null;
  nextActionOwnerUserId: string | null;
  nextActionNote: string | null;
};

export type GetSupportIssuesPageQueryVariables = Exact<{
  filter?: Types.SupportIssueFilterInput | null | undefined;
  offset?: number | null | undefined;
  limit?: number | null | undefined;
}>;

export type GetSupportIssuesPageQuery = {
  getSupportIssuesPage: {
    totalCount: number;
    offset: number;
    limit: number;
    hasMore: boolean;
    items: Array<{
      issueId: string;
      version: number;
      organizationId: string;
      supportTeamId: string;
      title: string;
      status: Types.SupportIssueStatus;
      priority: Types.SupportIssuePriority;
      deadlineDate: string | null;
      assigneeUserId: string | null;
      sourceType: Types.SupportIssueSourceType;
      sourceSupportThreadId: string | null;
      sourceConversationId: string | null;
      sourceContext: string | null;
      tags: Array<string>;
      createdAt: number;
      updatedAt: number;
      nextActionType: Types.SupportIssueNextActionType | null;
      nextActionAt: number | null;
      nextActionOwnerUserId: string | null;
      nextActionNote: string | null;
    }>;
  };
};

export type GetSupportIssueQueueSummaryQueryVariables = Exact<{
  filter?: Types.SupportIssueFilterInput | null | undefined;
}>;

export type GetSupportIssueQueueSummaryQuery = {
  getSupportIssueQueueSummary: {
    total: number;
    unassigned: number;
    overdue: number;
    dueToday: number;
    due7d: number;
    urgentCount: number;
    noDeadlineCount: number;
    countsByStatus: Array<{ status: Types.SupportIssueStatus; count: number }>;
  };
};

export type GetSupportIssueTimelineQueryVariables = Exact<{
  issueId: string;
  offset?: number | null | undefined;
  limit?: number | null | undefined;
}>;

export type GetSupportIssueTimelineQuery = {
  getSupportIssueTimeline: {
    totalCount: number;
    offset: number;
    limit: number;
    hasMore: boolean;
    items: Array<{
      eventId: string;
      actorUserId: string;
      eventType: Types.SupportIssueAuditEventType;
      issueVersion: number;
      occurredAt: number;
      changes: Array<{
        field: string;
        previousValue: string | null;
        nextValue: string | null;
      }>;
    }>;
  };
};

export type SupportIssueNotificationFieldsFragment = {
  notificationId: string;
  eventId: string;
  issueId: string;
  issueVersion: number;
  recipientUserId: string;
  supportTeamId: string;
  organizationId: string;
  actorUserId: string;
  eventType: Types.SupportIssueAuditEventType;
  title: string;
  body: string;
  occurredAt: number;
  readAt: number | null;
  changes: Array<{
    field: string;
    previousValue: string | null;
    nextValue: string | null;
  }>;
};

export type MySupportIssueNotificationsQueryVariables = Exact<{
  offset?: number | null | undefined;
  limit?: number | null | undefined;
  unreadOnly?: boolean | null | undefined;
}>;

export type MySupportIssueNotificationsQuery = {
  mySupportIssueNotifications: {
    totalCount: number;
    unreadCount: number;
    offset: number;
    limit: number;
    hasMore: boolean;
    items: Array<{
      notificationId: string;
      eventId: string;
      issueId: string;
      issueVersion: number;
      recipientUserId: string;
      supportTeamId: string;
      organizationId: string;
      actorUserId: string;
      eventType: Types.SupportIssueAuditEventType;
      title: string;
      body: string;
      occurredAt: number;
      readAt: number | null;
      changes: Array<{
        field: string;
        previousValue: string | null;
        nextValue: string | null;
      }>;
    }>;
  };
};

export type MarkSupportIssueNotificationReadMutationVariables = Exact<{
  notificationId: string;
}>;

export type MarkSupportIssueNotificationReadMutation = {
  markSupportIssueNotificationRead: {
    notificationId: string;
    eventId: string;
    issueId: string;
    issueVersion: number;
    recipientUserId: string;
    supportTeamId: string;
    organizationId: string;
    actorUserId: string;
    eventType: Types.SupportIssueAuditEventType;
    title: string;
    body: string;
    occurredAt: number;
    readAt: number | null;
    changes: Array<{
      field: string;
      previousValue: string | null;
      nextValue: string | null;
    }>;
  };
};

export type MarkAllSupportIssueNotificationsReadMutationVariables = Exact<{
  [key: string]: never;
}>;

export type MarkAllSupportIssueNotificationsReadMutation = {
  markAllSupportIssueNotificationsRead: number;
};

export type WatchSupportIssueNotificationSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type WatchSupportIssueNotificationSubscription = {
  supportIssueNotificationCreated: {
    notificationId: string;
    eventId: string;
    issueId: string;
    issueVersion: number;
    recipientUserId: string;
    supportTeamId: string;
    organizationId: string;
    actorUserId: string;
    eventType: Types.SupportIssueAuditEventType;
    title: string;
    body: string;
    occurredAt: number;
    readAt: number | null;
    changes: Array<{
      field: string;
      previousValue: string | null;
      nextValue: string | null;
    }>;
  };
};

export type GetSupportIssueQueryVariables = Exact<{
  issueId: string;
}>;

export type GetSupportIssueQuery = {
  getSupportIssue: {
    issueId: string;
    version: number;
    organizationId: string;
    supportTeamId: string;
    title: string;
    description: string | null;
    status: Types.SupportIssueStatus;
    allowedStatusTransitions: Array<Types.SupportIssueStatus>;
    priority: Types.SupportIssuePriority;
    deadlineDate: string | null;
    assigneeUserId: string | null;
    reporterUserId: string;
    sourceType: Types.SupportIssueSourceType;
    sourceSupportThreadId: string | null;
    sourceConversationId: string | null;
    sourceContext: string | null;
    sourceContextId: string | null;
    supportedUserId: string | null;
    messageSummary: string | null;
    tags: Array<string>;
    createdAt: number;
    updatedAt: number;
    triagedAt: number | null;
    triagedBy: string | null;
    nextActionType: Types.SupportIssueNextActionType | null;
    nextActionAt: number | null;
    nextActionOwnerUserId: string | null;
    nextActionNote: string | null;
    resolutionCode: Types.SupportIssueResolutionCode | null;
    resolutionSummary: string | null;
    resolvedBy: string | null;
    lastReopenReason: string | null;
    reopenCount: number;
    lastReopenedAt: number | null;
    lastReopenedBy: string | null;
    closedAt: number | null;
    extractedLinks: Array<{
      url: string;
      domain: string | null;
      kind: string | null;
      label: string | null;
      firstSeenAt: number | null;
      firstSeenMessageId: string | null;
    }>;
    customerSnapshot: {
      userId: string | null;
      displayName: string | null;
      email: string | null;
      phone: string | null;
      verifiedPhone: boolean | null;
      type: Array<Types.OldUserType | null> | null;
      clientSessionsCount: number | null;
      photographerPrivateSessionsCount: number | null;
      photographerPublicSessionsCount: number | null;
      photographerAlbumDesignCount: number | null;
      photographerWeddingCount: number | null;
      photographerGalleryCount: number | null;
      photographerBookingsCount: number | null;
      sessions: Array<{
        name: string | null;
        oldSessionDetailsId: string | null;
        created: number | null;
        photographer: {
          userId: string | null;
          name: string | null;
          login: string | null;
          phone: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetSupportIssueAssigneesQueryVariables = Exact<{
  supportTeamId?: string | null | undefined;
}>;

export type GetSupportIssueAssigneesQuery = {
  getSupportIssueAssignees: Array<{
    userId: string;
    displayName: string | null;
    login: string | null;
  }>;
};

export type GetSupportIssueTagsQueryVariables = Exact<{
  query?: string | null | undefined;
  limit?: number | null | undefined;
  supportTeamId?: string | null | undefined;
}>;

export type GetSupportIssueTagsQuery = { getSupportIssueTags: Array<string> };

export type SupportThreadAiSuggestionFieldsFragment = {
  supportThreadAiSuggestionId: string;
  supportThreadId: string;
  question: string;
  answer: string;
  confidence: number;
  createdAt: number;
  myRating: number | null;
  averageRating: number | null;
  ratingsCount: number;
  ratings: Array<{
    supportUserId: string;
    rating: number;
    createdAt: number;
    updatedAt: number;
  }>;
};

export type SupportThreadAiAnalysisStatusFieldsFragment = {
  supportThreadId: string;
  status: Types.SupportThreadAiAnalysisState;
  errorMessage: string | null;
  suggestionsCount: number;
  updatedAt: number;
};

export type GetSupportThreadAiSuggestionsQueryVariables = Exact<{
  supportThreadId: string;
}>;

export type GetSupportThreadAiSuggestionsQuery = {
  getSupportThreadAiSuggestions: Array<{
    supportThreadAiSuggestionId: string;
    supportThreadId: string;
    question: string;
    answer: string;
    confidence: number;
    createdAt: number;
    myRating: number | null;
    averageRating: number | null;
    ratingsCount: number;
    ratings: Array<{
      supportUserId: string;
      rating: number;
      createdAt: number;
      updatedAt: number;
    }>;
  }>;
};

export type GetSupportThreadAiAnalysisStatusQueryVariables = Exact<{
  supportThreadId: string;
}>;

export type GetSupportThreadAiAnalysisStatusQuery = {
  getSupportThreadAiAnalysisStatus: {
    supportThreadId: string;
    status: Types.SupportThreadAiAnalysisState;
    errorMessage: string | null;
    suggestionsCount: number;
    updatedAt: number;
  };
};

export type GetChatMessagesForSupportQueryVariables = Exact<{
  offset?: number | null | undefined;
  limit?: number | null | undefined;
  conversationId: string;
}>;

export type GetChatMessagesForSupportQuery = {
  getSupportChatMessages: Array<{
    authorId: string | null;
    comment: string | null;
    date: number | null;
    type: Types.CommnetType | null;
    standaloneSupportMessageId: string | null;
  } | null> | null;
};

export type InsertSupportMessageMutationVariables = Exact<{
  message: string;
  type: Types.CommnetType;
  standaloneSupportMessageId: string;
  conversationId: string;
}>;

export type InsertSupportMessageMutation = {
  insertMessageFromSupport: {
    authorId: string | null;
    comment: string | null;
    date: number | null;
    standaloneSupportMessageId: string | null;
    type: Types.CommnetType | null;
  } | null;
};

export type GetNewMessagesSubscriptionVariables = Exact<{
  supportThreadId: string;
}>;

export type GetNewMessagesSubscription = {
  messageToSupportSent: {
    authorId: string | null;
    comment: string | null;
    date: number | null;
    standaloneSupportMessageId: string | null;
    type: Types.CommnetType | null;
  } | null;
};

export type SupportThreadUpdatedSubscriptionVariables = Exact<{
  supportTeamId: string;
}>;

export type SupportThreadUpdatedSubscription = {
  supportThreadUpdated: {
    supportRequestId: string | null;
    version: Types.SupportSystemVersion | null;
    isAnswered: boolean | null;
    isSolved: boolean | null;
    currentSupportManagerId: string | null;
    lastMessage: string | null;
    lastMessageDate: number | null;
    organizationId: string | null;
    supportTeamId: string | null;
    supportedUserId: string | null;
    context: Types.ZalamoSupportContext | null;
    ownerState: Types.SupportOwnerState | null;
    isRead: boolean | null;
    conversationId: string | null;
    isSeenByClient: boolean | null;
    studio: {
      organizationId: string;
      name: string | null;
      zalamoPayConfigFinished: boolean | null;
      zalamoPayRegisterInProgress: boolean | null;
    } | null;
    mobileDevice: {
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    } | null;
    mobileDevices: Array<{
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    }>;
  } | null;
};

export type UpdateSupportThreadMutationVariables = Exact<{
  supportThreadId: string;
  input: Types.ThreadUpdateInput;
}>;

export type UpdateSupportThreadMutation = {
  updateThread: {
    supportRequestId: string | null;
    version: Types.SupportSystemVersion | null;
    isAnswered: boolean | null;
    isSolved: boolean | null;
    currentSupportManagerId: string | null;
    lastMessage: string | null;
    lastMessageDate: number | null;
    organizationId: string | null;
    supportTeamId: string | null;
    supportedUserId: string | null;
    context: Types.ZalamoSupportContext | null;
    ownerState: Types.SupportOwnerState | null;
    isRead: boolean | null;
    conversationId: string | null;
    isSeenByClient: boolean | null;
    studio: {
      organizationId: string;
      name: string | null;
      zalamoPayConfigFinished: boolean | null;
      zalamoPayRegisterInProgress: boolean | null;
    } | null;
    mobileDevice: {
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    } | null;
    mobileDevices: Array<{
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    }>;
  } | null;
};

export type CreateSupportIssueFromThreadMutationVariables = Exact<{
  supportThreadId: string;
  input: Types.CreateSupportIssueFromThreadInput;
}>;

export type CreateSupportIssueFromThreadMutation = {
  createSupportIssueFromSupportThread: {
    issueId: string;
    version: number;
    organizationId: string;
    supportTeamId: string;
    title: string;
    description: string | null;
    status: Types.SupportIssueStatus;
    allowedStatusTransitions: Array<Types.SupportIssueStatus>;
    priority: Types.SupportIssuePriority;
    deadlineDate: string | null;
    assigneeUserId: string | null;
    reporterUserId: string;
    sourceType: Types.SupportIssueSourceType;
    sourceSupportThreadId: string | null;
    sourceConversationId: string | null;
    sourceContext: string | null;
    sourceContextId: string | null;
    supportedUserId: string | null;
    messageSummary: string | null;
    tags: Array<string>;
    createdAt: number;
    updatedAt: number;
    triagedAt: number | null;
    triagedBy: string | null;
    nextActionType: Types.SupportIssueNextActionType | null;
    nextActionAt: number | null;
    nextActionOwnerUserId: string | null;
    nextActionNote: string | null;
    resolutionCode: Types.SupportIssueResolutionCode | null;
    resolutionSummary: string | null;
    resolvedBy: string | null;
    lastReopenReason: string | null;
    reopenCount: number;
    lastReopenedAt: number | null;
    lastReopenedBy: string | null;
    closedAt: number | null;
    extractedLinks: Array<{
      url: string;
      domain: string | null;
      kind: string | null;
      label: string | null;
      firstSeenAt: number | null;
      firstSeenMessageId: string | null;
    }>;
    customerSnapshot: {
      userId: string | null;
      displayName: string | null;
      email: string | null;
      phone: string | null;
      verifiedPhone: boolean | null;
      type: Array<Types.OldUserType | null> | null;
      clientSessionsCount: number | null;
      photographerPrivateSessionsCount: number | null;
      photographerPublicSessionsCount: number | null;
      photographerAlbumDesignCount: number | null;
      photographerWeddingCount: number | null;
      photographerGalleryCount: number | null;
      photographerBookingsCount: number | null;
      sessions: Array<{
        name: string | null;
        oldSessionDetailsId: string | null;
        created: number | null;
        photographer: {
          userId: string | null;
          name: string | null;
          login: string | null;
          phone: string | null;
        } | null;
      } | null> | null;
    } | null;
  };
};

export type CreateSupportIssueMutationVariables = Exact<{
  input: Types.CreateSupportIssueInput;
}>;

export type CreateSupportIssueMutation = {
  createSupportIssue: {
    issueId: string;
    version: number;
    organizationId: string;
    supportTeamId: string;
    title: string;
    description: string | null;
    status: Types.SupportIssueStatus;
    allowedStatusTransitions: Array<Types.SupportIssueStatus>;
    priority: Types.SupportIssuePriority;
    deadlineDate: string | null;
    assigneeUserId: string | null;
    reporterUserId: string;
    sourceType: Types.SupportIssueSourceType;
    sourceSupportThreadId: string | null;
    sourceConversationId: string | null;
    sourceContext: string | null;
    sourceContextId: string | null;
    supportedUserId: string | null;
    messageSummary: string | null;
    tags: Array<string>;
    createdAt: number;
    updatedAt: number;
    triagedAt: number | null;
    triagedBy: string | null;
    nextActionType: Types.SupportIssueNextActionType | null;
    nextActionAt: number | null;
    nextActionOwnerUserId: string | null;
    nextActionNote: string | null;
    resolutionCode: Types.SupportIssueResolutionCode | null;
    resolutionSummary: string | null;
    resolvedBy: string | null;
    lastReopenReason: string | null;
    reopenCount: number;
    lastReopenedAt: number | null;
    lastReopenedBy: string | null;
    closedAt: number | null;
    extractedLinks: Array<{
      url: string;
      domain: string | null;
      kind: string | null;
      label: string | null;
      firstSeenAt: number | null;
      firstSeenMessageId: string | null;
    }>;
    customerSnapshot: {
      userId: string | null;
      displayName: string | null;
      email: string | null;
      phone: string | null;
      verifiedPhone: boolean | null;
      type: Array<Types.OldUserType | null> | null;
      clientSessionsCount: number | null;
      photographerPrivateSessionsCount: number | null;
      photographerPublicSessionsCount: number | null;
      photographerAlbumDesignCount: number | null;
      photographerWeddingCount: number | null;
      photographerGalleryCount: number | null;
      photographerBookingsCount: number | null;
      sessions: Array<{
        name: string | null;
        oldSessionDetailsId: string | null;
        created: number | null;
        photographer: {
          userId: string | null;
          name: string | null;
          login: string | null;
          phone: string | null;
        } | null;
      } | null> | null;
    } | null;
  };
};

export type UpdateSupportIssueMutationVariables = Exact<{
  issueId: string;
  input: Types.UpdateSupportIssueInput;
}>;

export type UpdateSupportIssueMutation = {
  updateSupportIssue: {
    issueId: string;
    version: number;
    organizationId: string;
    supportTeamId: string;
    title: string;
    description: string | null;
    status: Types.SupportIssueStatus;
    allowedStatusTransitions: Array<Types.SupportIssueStatus>;
    priority: Types.SupportIssuePriority;
    deadlineDate: string | null;
    assigneeUserId: string | null;
    reporterUserId: string;
    sourceType: Types.SupportIssueSourceType;
    sourceSupportThreadId: string | null;
    sourceConversationId: string | null;
    sourceContext: string | null;
    sourceContextId: string | null;
    supportedUserId: string | null;
    messageSummary: string | null;
    tags: Array<string>;
    createdAt: number;
    updatedAt: number;
    triagedAt: number | null;
    triagedBy: string | null;
    nextActionType: Types.SupportIssueNextActionType | null;
    nextActionAt: number | null;
    nextActionOwnerUserId: string | null;
    nextActionNote: string | null;
    resolutionCode: Types.SupportIssueResolutionCode | null;
    resolutionSummary: string | null;
    resolvedBy: string | null;
    lastReopenReason: string | null;
    reopenCount: number;
    lastReopenedAt: number | null;
    lastReopenedBy: string | null;
    closedAt: number | null;
    extractedLinks: Array<{
      url: string;
      domain: string | null;
      kind: string | null;
      label: string | null;
      firstSeenAt: number | null;
      firstSeenMessageId: string | null;
    }>;
    customerSnapshot: {
      userId: string | null;
      displayName: string | null;
      email: string | null;
      phone: string | null;
      verifiedPhone: boolean | null;
      type: Array<Types.OldUserType | null> | null;
      clientSessionsCount: number | null;
      photographerPrivateSessionsCount: number | null;
      photographerPublicSessionsCount: number | null;
      photographerAlbumDesignCount: number | null;
      photographerWeddingCount: number | null;
      photographerGalleryCount: number | null;
      photographerBookingsCount: number | null;
      sessions: Array<{
        name: string | null;
        oldSessionDetailsId: string | null;
        created: number | null;
        photographer: {
          userId: string | null;
          name: string | null;
          login: string | null;
          phone: string | null;
        } | null;
      } | null> | null;
    } | null;
  };
};

export type GenerateSupportThreadAiSuggestionsMutationVariables = Exact<{
  supportThreadId: string;
}>;

export type GenerateSupportThreadAiSuggestionsMutation = {
  generateSupportThreadAiSuggestions: {
    supportThreadId: string;
    status: Types.SupportThreadAiAnalysisState;
    errorMessage: string | null;
    suggestionsCount: number;
    updatedAt: number;
  };
};

export type WatchSupportThreadAiAnalysisStatusSubscriptionVariables = Exact<{
  supportThreadId: string;
}>;

export type WatchSupportThreadAiAnalysisStatusSubscription = {
  supportThreadAiAnalysisStatusUpdated: {
    supportThreadId: string;
    status: Types.SupportThreadAiAnalysisState;
    errorMessage: string | null;
    suggestionsCount: number;
    updatedAt: number;
  };
};

export type SetSupportThreadAiSuggestionRatingMutationVariables = Exact<{
  supportThreadAiSuggestionId: string;
  rating: number;
}>;

export type SetSupportThreadAiSuggestionRatingMutation = {
  setSupportThreadAiSuggestionRating: {
    supportThreadAiSuggestionId: string;
    supportThreadId: string;
    question: string;
    answer: string;
    confidence: number;
    createdAt: number;
    myRating: number | null;
    averageRating: number | null;
    ratingsCount: number;
    ratings: Array<{
      supportUserId: string;
      rating: number;
      createdAt: number;
      updatedAt: number;
    }>;
  };
};

export type MineDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type MineDetailsQuery = {
  getMe: {
    supportTeamMemberId: string | null;
    teamMemberId: string | null;
    supportTeamId: string | null;
    activeSupportTeams: Array<{ supportTeamId: string; label: string }>;
  } | null;
};

export type WatchForThreadUpdatedSubscriptionVariables = Exact<{
  supportTeamId: string;
}>;

export type WatchForThreadUpdatedSubscription = {
  supportThreadUpdated: {
    supportRequestId: string | null;
    version: Types.SupportSystemVersion | null;
    isAnswered: boolean | null;
    isSolved: boolean | null;
    currentSupportManagerId: string | null;
    lastMessage: string | null;
    lastMessageDate: number | null;
    organizationId: string | null;
    supportTeamId: string | null;
    supportedUserId: string | null;
    context: Types.ZalamoSupportContext | null;
    ownerState: Types.SupportOwnerState | null;
    isRead: boolean | null;
    conversationId: string | null;
    isSeenByClient: boolean | null;
    studio: {
      organizationId: string;
      name: string | null;
      zalamoPayConfigFinished: boolean | null;
      zalamoPayRegisterInProgress: boolean | null;
    } | null;
    mobileDevice: {
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    } | null;
    mobileDevices: Array<{
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    }>;
  } | null;
};

export type WatchForNewSupportThreadsSubscriptionVariables = Exact<{
  supportTeamId: string;
}>;

export type WatchForNewSupportThreadsSubscription = {
  supportThreadCreatedByUser: {
    supportRequestId: string | null;
    version: Types.SupportSystemVersion | null;
    isAnswered: boolean | null;
    isSolved: boolean | null;
    currentSupportManagerId: string | null;
    lastMessage: string | null;
    lastMessageDate: number | null;
    organizationId: string | null;
    supportTeamId: string | null;
    supportedUserId: string | null;
    context: Types.ZalamoSupportContext | null;
    ownerState: Types.SupportOwnerState | null;
    isRead: boolean | null;
    conversationId: string | null;
    isSeenByClient: boolean | null;
    studio: {
      organizationId: string;
      name: string | null;
      zalamoPayConfigFinished: boolean | null;
      zalamoPayRegisterInProgress: boolean | null;
    } | null;
    mobileDevice: {
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    } | null;
    mobileDevices: Array<{
      deviceId: string;
      summaryLabel: string;
      isLoggedIn: boolean;
      platform: string | null;
      model: string | null;
      version: string | null;
      language: string | null;
      pushAvailable: boolean;
      notificationsAuthorized: boolean | null;
      firstSeenAt: string | null;
      updatedAt: string | null;
      currentUser: {
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      } | null;
      linkedUsers: Array<{
        userId: string;
        displayName: string | null;
        email: string | null;
        isActive: boolean;
        firstLinkedAt: string | null;
        lastLinkedAt: string | null;
      }>;
      visitedPublicSessions: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedSignups: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
      visitedOrders: Array<{
        hash: string | null;
        signupId: string | null;
        childId: string | null;
        orderId: string | null;
        lastVisitedAt: string;
      }>;
    }>;
  } | null;
};

export type LoginAsMutationVariables = Exact<{
  userId?: string | null | undefined;
  type?: Types.UserType | null | undefined;
}>;

export type LoginAsMutation = { createAutoLogin: string | null };

export type GetNamesForAllSupportedClientsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetNamesForAllSupportedClientsQuery = {
  getNamesForAllSupportedClients: Array<{
    email: string | null;
    name: string | null;
    organizationName: string | null;
    organizationId: string | null;
    phone: string | null;
    supportedClientIdentifierId: string | null;
  } | null> | null;
};

export type GetLastSeenForUserQueryVariables = Exact<{
  userId: string;
  organizationId: string;
}>;

export type GetLastSeenForUserQuery = {
  getLastSeen: Array<{
    id: string | null;
    type: Types.ZalamoObject | null;
  } | null> | null;
};

export type FindOldUserQueryVariables = Exact<{
  query?: string | null | undefined;
}>;

export type FindOldUserQuery = {
  findOldZalamoUser: Array<{
    type: Array<Types.OldUserType | null> | null;
    userId: string | null;
    name: string | null;
    login: string | null;
    phone: string | null;
    lastSeen: number | null;
  } | null> | null;
};

export type GetOldUserDetailsQueryVariables = Exact<{
  userId?: string | null | undefined;
}>;

export type GetOldUserDetailsQuery = {
  getOldUserDetails: {
    clientSessionsCount: number | null;
    oldUserDetailsId: string | null;
    verifiedPhone: boolean | null;
    photographerAlbumDesignCount: number | null;
    photographerBookingsCount: number | null;
    photographerGalleryCount: number | null;
    photographerPrivateSessionsCount: number | null;
    photographerPublicSessionsCount: number | null;
    photographerWeddingCount: number | null;
    type: Array<Types.OldUserType | null> | null;
    sessions: Array<{
      name: string | null;
      oldSessionDetailsId: string | null;
      created: number | null;
      photographer: {
        login: string | null;
        name: string | null;
        phone: string | null;
        userId: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type MakrPhoneNumberAsVerifiedMutationVariables = Exact<{
  userId: string;
}>;

export type MakrPhoneNumberAsVerifiedMutation = {
  makrPhoneNumberAsVerified: {
    oldUserDetailsId: string | null;
    verifiedPhone: boolean | null;
  } | null;
};

export type GetZalamoStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetZalamoStatsQuery = {
  newZalamoStats: {
    imagesPerformance: Array<{
      avg: number | null;
      count: number | null;
      p25: number | null;
      p50: number | null;
      p75: number | null;
      p90: number | null;
      p100: number | null;
      time: number | null;
    } | null> | null;
    zalamoPay: { errors: number | null; todayCount: number | null } | null;
    frames: {
      enabled: Array<{
        context: string | null;
        count: number | null;
        organizationName: string | null;
      } | null> | null;
    } | null;
    orders: {
      days: Array<{
        orders: number | null;
        date: string | null;
        revenue: number | null;
        currency: string | null;
        orgCount: number | null;
        context: string | null;
      } | null> | null;
      months: Array<{
        revenue: number | null;
        date: string | null;
        orders: number | null;
        currency: string | null;
        orgCount: number | null;
        context: string | null;
      } | null> | null;
      topOrgsDaily: Array<{
        revenue: number | null;
        name: string | null;
        ordersCount: number | null;
      } | null> | null;
      topOrgsWeekly: Array<{
        revenue: number | null;
        name: string | null;
        ordersCount: number | null;
      } | null> | null;
      topOrgsMonthly: Array<{
        revenue: number | null;
        name: string | null;
        ordersCount: number | null;
      } | null> | null;
      topOrgsYearly: Array<{
        revenue: number | null;
        name: string | null;
        ordersCount: number | null;
      } | null> | null;
      framesLastWeek: Array<{
        context: string | null;
        currency: string | null;
        date: string | null;
        orders: number | null;
        orgCount: number | null;
        revenue: number | null;
        productCount: number | null;
      } | null> | null;
      wallDecor: Array<{
        context: string | null;
        currency: string | null;
        date: string | null;
        orders: number | null;
        orgCount: number | null;
        revenue: number | null;
        productCount: number | null;
      } | null> | null;
    } | null;
    usage: {
      publicSessions: Array<{
        orgCount: number | null;
        count: number | null;
        month: string | null;
      } | null> | null;
      privateSessions: Array<{
        orgCount: number | null;
        count: number | null;
        month: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetPrivateSessionClientUserIdQueryVariables = Exact<{
  privateSessionId: string;
}>;

export type GetPrivateSessionClientUserIdQuery = {
  getPrivateSessionClientUserId: string | null;
};

export type RestoreArchiveMutationVariables = Exact<{
  subject?: string | null | undefined;
}>;

export type RestoreArchiveMutation = { restoreArchive: number | null };

export type SchoolFragment = {
  schoolDetailsId: string | null;
  name: string | null;
  email: string | null;
  phone: string | null;
  showSimple: boolean | null;
  showChips: boolean | null;
  contactEmail: string | null;
  contactPhone: string | null;
  pickedBy: string | null;
  decisionMakerName: string | null;
  decisionMakerPosition: string | null;
  emailSent: boolean | null;
  emailSentDate: number | null;
  uid: string | null;
  ai: { denominator: string | null; genitive: string | null } | null;
};

export type GetSchoolDetailsQueryVariables = Exact<{
  schoolId: string;
}>;

export type GetSchoolDetailsQuery = {
  getSchoolDetails: {
    schoolDetailsId: string | null;
    name: string | null;
    email: string | null;
    phone: string | null;
    showSimple: boolean | null;
    showChips: boolean | null;
    contactEmail: string | null;
    contactPhone: string | null;
    pickedBy: string | null;
    decisionMakerName: string | null;
    decisionMakerPosition: string | null;
    emailSent: boolean | null;
    emailSentDate: number | null;
    uid: string | null;
    ai: { denominator: string | null; genitive: string | null } | null;
  } | null;
};

export type UpdateSchoolDetailsMutationVariables = Exact<{
  schoolId: string;
  input?: Types.SchoolDetailsInput | null | undefined;
}>;

export type UpdateSchoolDetailsMutation = {
  updateSchoolDetails: {
    schoolDetailsId: string | null;
    name: string | null;
    email: string | null;
    phone: string | null;
    showSimple: boolean | null;
    showChips: boolean | null;
    contactEmail: string | null;
    contactPhone: string | null;
    pickedBy: string | null;
    decisionMakerName: string | null;
    decisionMakerPosition: string | null;
    emailSent: boolean | null;
    emailSentDate: number | null;
    uid: string | null;
    ai: { denominator: string | null; genitive: string | null } | null;
  } | null;
};

export type SendMailToSchoolMutationVariables = Exact<{
  schoolId: string;
}>;

export type SendMailToSchoolMutation = {
  sendMailToSchool: {
    schoolDetailsId: string | null;
    name: string | null;
    email: string | null;
    phone: string | null;
    showSimple: boolean | null;
    showChips: boolean | null;
    contactEmail: string | null;
    contactPhone: string | null;
    pickedBy: string | null;
    decisionMakerName: string | null;
    decisionMakerPosition: string | null;
    emailSent: boolean | null;
    emailSentDate: number | null;
    uid: string | null;
    ai: { denominator: string | null; genitive: string | null } | null;
  } | null;
};

export type ShowEnabledPaymentMethodsQueryVariables = Exact<{
  userId: number;
}>;

export type ShowEnabledPaymentMethodsQuery = {
  showEnabledPaymentMethods: Array<{
    paymentMethodId: string | null;
    name: string | null;
  } | null> | null;
};

export type DeletePaymentMethodMutationVariables = Exact<{
  paymentMethodId: string;
  userId: number;
}>;

export type DeletePaymentMethodMutation = {
  deletePaymentMethod: boolean | null;
};

export type ChangePhotographerSubdomainMutationVariables = Exact<{
  subdomain: string;
  newSubdomain: string;
}>;

export type ChangePhotographerSubdomainMutation = {
  changePhotographerSubdomain: number | null;
};

export type UpdatePublicSessionProlongationMutationVariables = Exact<{
  publicSessionId: string;
  prolongation: number;
}>;

export type UpdatePublicSessionProlongationMutation = {
  updatePublicSessionProlongation: boolean | null;
};

export type FindSessionUserIdByHashQueryVariables = Exact<{
  hash: string;
}>;

export type FindSessionUserIdByHashQuery = {
  findSessionUserIdByHash: {
    userId: number | null;
    organizationId: string | null;
  } | null;
};

export type GetSupportUserTestsQueryVariables = Exact<{
  userId: string;
}>;

export type GetSupportUserTestsQuery = {
  getSupportUserTests: {
    userId: string;
    availableTests: Array<Types.UserTest>;
    activeTests: Array<Types.UserTest>;
  };
};

export type UpdateSupportUserTestsMutationVariables = Exact<{
  userId: string;
  tests: Array<Types.UserTest> | Types.UserTest;
}>;

export type UpdateSupportUserTestsMutation = {
  updateSupportUserTests: {
    userId: string;
    availableTests: Array<Types.UserTest>;
    activeTests: Array<Types.UserTest>;
  };
};

export type ClearSupportUserTestsCacheMutationVariables = Exact<{
  userId: string;
}>;

export type ClearSupportUserTestsCacheMutation = {
  clearSupportUserTestsCache: boolean;
};

export type GetSupportOrganizationTestsQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetSupportOrganizationTestsQuery = {
  getSupportOrganizationTests: {
    organizationId: string;
    availableTests: Array<Types.OrganizationTest>;
    activeTests: Array<Types.OrganizationTest>;
  };
};

export type UpdateSupportOrganizationTestsMutationVariables = Exact<{
  organizationId: string;
  tests: Array<Types.OrganizationTest> | Types.OrganizationTest;
}>;

export type UpdateSupportOrganizationTestsMutation = {
  updateSupportOrganizationTests: {
    organizationId: string;
    availableTests: Array<Types.OrganizationTest>;
    activeTests: Array<Types.OrganizationTest>;
  };
};

export type TextSnippetDetailsFragment = {
  supportSnippetId: string;
  title: string;
  supportTeamId: string;
  createdAt: number | null;
  updatedAt: number | null;
  content: Array<{ language: string; text: string }>;
};

export type GetTextSnippetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTextSnippetsQuery = {
  getTextSnippets: Array<{
    supportSnippetId: string;
    title: string;
    supportTeamId: string;
    createdAt: number | null;
    updatedAt: number | null;
    content: Array<{ language: string; text: string }>;
  }>;
};

export type CreateTextSnippetMutationVariables = Exact<{
  supportSnippetId: string;
  title: string;
  content: Array<Types.I18nTextInput> | Types.I18nTextInput;
}>;

export type CreateTextSnippetMutation = {
  createTextSnippet: {
    supportSnippetId: string;
    title: string;
    supportTeamId: string;
    createdAt: number | null;
    updatedAt: number | null;
    content: Array<{ language: string; text: string }>;
  };
};

export type UpdateTextSnippetMutationVariables = Exact<{
  supportSnippetId: string;
  title: string;
  content: Array<Types.I18nTextInput> | Types.I18nTextInput;
}>;

export type UpdateTextSnippetMutation = {
  updateTextSnippet: {
    supportSnippetId: string;
    title: string;
    supportTeamId: string;
    createdAt: number | null;
    updatedAt: number | null;
    content: Array<{ language: string; text: string }>;
  };
};

export type DeleteTextSnippetMutationVariables = Exact<{
  supportSnippetId: string;
}>;

export type DeleteTextSnippetMutation = {
  deleteTextSnippet: { supportSnippetId: string };
};

export const SupportMobileDeviceUserDetailsFragmentDoc = gql`
  fragment SupportMobileDeviceUserDetails on SupportMobileDeviceUser {
    userId
    displayName
    email
    isActive
    firstLinkedAt
    lastLinkedAt
  }
`;
export const SupportMobileDeviceVisitDetailsFragmentDoc = gql`
  fragment SupportMobileDeviceVisitDetails on SupportMobileDeviceVisit {
    hash
    signupId
    childId
    orderId
    lastVisitedAt
  }
`;
export const SupportMobileDeviceDetailsFragmentDoc = gql`
  fragment SupportMobileDeviceDetails on SupportMobileDeviceDetails {
    deviceId
    summaryLabel
    isLoggedIn
    currentUser {
      ...SupportMobileDeviceUserDetails
    }
    linkedUsers {
      ...SupportMobileDeviceUserDetails
    }
    platform
    model
    version
    language
    pushAvailable
    notificationsAuthorized
    firstSeenAt
    updatedAt
    visitedPublicSessions {
      ...SupportMobileDeviceVisitDetails
    }
    visitedSignups {
      ...SupportMobileDeviceVisitDetails
    }
    visitedOrders {
      ...SupportMobileDeviceVisitDetails
    }
  }
  ${SupportMobileDeviceUserDetailsFragmentDoc}
  ${SupportMobileDeviceVisitDetailsFragmentDoc}
`;
export const SupportThreadDetailsFragmentDoc = gql`
  fragment SupportThreadDetails on SupportRequest {
    supportRequestId
    version
    isAnswered
    isSolved
    currentSupportManagerId
    lastMessage
    lastMessageDate
    organizationId
    supportTeamId
    supportedUserId
    context
    ownerState
    isRead
    conversationId
    isSeenByClient
    studio {
      organizationId
      name
      zalamoPayConfigFinished
      zalamoPayRegisterInProgress
    }
    mobileDevice {
      ...SupportMobileDeviceDetails
    }
    mobileDevices {
      ...SupportMobileDeviceDetails
    }
  }
  ${SupportMobileDeviceDetailsFragmentDoc}
`;
export const SupportIssueDetailsFragmentDoc = gql`
  fragment SupportIssueDetails on SupportIssue {
    issueId
    version
    organizationId
    supportTeamId
    title
    description
    status
    allowedStatusTransitions
    priority
    deadlineDate
    assigneeUserId
    reporterUserId
    sourceType
    sourceSupportThreadId
    sourceConversationId
    sourceContext
    sourceContextId
    supportedUserId
    messageSummary
    tags
    extractedLinks {
      url
      domain
      kind
      label
      firstSeenAt
      firstSeenMessageId
    }
    customerSnapshot {
      userId
      displayName
      email
      phone
      verifiedPhone
      type
      clientSessionsCount
      photographerPrivateSessionsCount
      photographerPublicSessionsCount
      photographerAlbumDesignCount
      photographerWeddingCount
      photographerGalleryCount
      photographerBookingsCount
      sessions {
        name
        oldSessionDetailsId
        created
        photographer {
          userId
          name
          login
          phone
        }
      }
    }
    createdAt
    updatedAt
    triagedAt
    triagedBy
    nextActionType
    nextActionAt
    nextActionOwnerUserId
    nextActionNote
    resolutionCode
    resolutionSummary
    resolvedBy
    lastReopenReason
    reopenCount
    lastReopenedAt
    lastReopenedBy
    closedAt
  }
`;
export const SupportIssueThreadListItemFragmentDoc = gql`
  fragment SupportIssueThreadListItem on SupportIssue {
    issueId
    title
    status
    priority
    deadlineDate
    assigneeUserId
    nextActionType
    nextActionAt
    nextActionOwnerUserId
    nextActionNote
    updatedAt
  }
`;
export const SupportIssueBoardListItemFragmentDoc = gql`
  fragment SupportIssueBoardListItem on SupportIssueListItem {
    issueId
    version
    organizationId
    supportTeamId
    title
    status
    priority
    deadlineDate
    assigneeUserId
    sourceType
    sourceSupportThreadId
    sourceConversationId
    sourceContext
    tags
    createdAt
    updatedAt
    nextActionType
    nextActionAt
    nextActionOwnerUserId
    nextActionNote
  }
`;
export const SupportIssueNotificationFieldsFragmentDoc = gql`
  fragment SupportIssueNotificationFields on SupportIssueNotification {
    notificationId
    eventId
    issueId
    issueVersion
    recipientUserId
    supportTeamId
    organizationId
    actorUserId
    eventType
    title
    body
    changes {
      field
      previousValue
      nextValue
    }
    occurredAt
    readAt
  }
`;
export const SupportThreadAiSuggestionFieldsFragmentDoc = gql`
  fragment SupportThreadAiSuggestionFields on SupportThreadAiSuggestion {
    supportThreadAiSuggestionId
    supportThreadId
    question
    answer
    confidence
    createdAt
    myRating
    averageRating
    ratingsCount
    ratings {
      supportUserId
      rating
      createdAt
      updatedAt
    }
  }
`;
export const SupportThreadAiAnalysisStatusFieldsFragmentDoc = gql`
  fragment SupportThreadAiAnalysisStatusFields on SupportThreadAiAnalysisStatus {
    supportThreadId
    status
    errorMessage
    suggestionsCount
    updatedAt
  }
`;
export const SchoolFragmentDoc = gql`
  fragment School on SchoolDetails {
    schoolDetailsId
    name
    email
    phone
    showSimple
    showChips
    contactEmail
    contactPhone
    pickedBy
    decisionMakerName
    decisionMakerPosition
    emailSent
    emailSentDate
    uid
    ai {
      denominator
      genitive
    }
  }
`;
export const TextSnippetDetailsFragmentDoc = gql`
  fragment TextSnippetDetails on TextSnippet {
    supportSnippetId
    title
    content {
      language
      text
    }
    supportTeamId
    createdAt
    updatedAt
  }
`;
export const SetMineOnlineStatusDocument = gql`
  mutation setMineOnlineStatus($isOnline: Boolean!) {
    updateMineOnlineState(imOnline: $isOnline) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetMineOnlineStatusGQL extends Apollo.Mutation<
  SetMineOnlineStatusMutation,
  SetMineOnlineStatusMutationVariables
> {
  document = SetMineOnlineStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MineStatusDocument = gql`
  query MineStatus {
    mineStatus {
      online
      mineStatusId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineStatusGQL extends Apollo.Query<
  MineStatusQuery,
  MineStatusQueryVariables
> {
  document = MineStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductsForProofingDocument = gql`
  query getProductsForProofing {
    getProductsForProofing {
      pagesCount
      productForProofingId
      sourceProductInOrderId
      sourceProjectId
      sourceProjectUserId
      productForProofingType
      pages {
        pageId
        sourcePhotoId
        label
        blobName
        blobRotation
        blobClip
        tabloProjectId
        organizationId
        blobTargetPosition {
          x
          y
        }
        blobTargetSize {
          width
          height
        }
        canvasTargetSize {
          width
          height
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductsForProofingGQL extends Apollo.Query<
  GetProductsForProofingQuery,
  GetProductsForProofingQueryVariables
> {
  document = GetProductsForProofingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkProductAsProofedDocument = gql`
  mutation markProductAsProofed($productForProofingId: ID!) {
    markProductAsProofed(productForProofingId: $productForProofingId) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MarkProductAsProofedGQL extends Apollo.Mutation<
  MarkProductAsProofedMutation,
  MarkProductAsProofedMutationVariables
> {
  document = MarkProductAsProofedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkProductAsBrokenDocument = gql`
  mutation markProductAsBroken($productForProofingId: ID!) {
    markProductAsBroken(productForProofingId: $productForProofingId) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MarkProductAsBrokenGQL extends Apollo.Mutation<
  MarkProductAsBrokenMutation,
  MarkProductAsBrokenMutationVariables
> {
  document = MarkProductAsBrokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RefreshTabloProofingRenderDocument = gql`
  mutation refreshTabloProofingRender($productForProofingId: ID!) {
    refreshTabloProofingRender(productForProofingId: $productForProofingId) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RefreshTabloProofingRenderGQL extends Apollo.Mutation<
  RefreshTabloProofingRenderMutation,
  RefreshTabloProofingRenderMutationVariables
> {
  document = RefreshTabloProofingRenderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SupportThreadsDocument = gql`
  query supportThreads($state: SupportOwnerState!) {
    currentSupportRequests(ownerState: $state) {
      supportRequestListId
      requests {
        ...SupportThreadDetails
      }
    }
  }
  ${SupportThreadDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SupportThreadsGQL extends Apollo.Query<
  SupportThreadsQuery,
  SupportThreadsQueryVariables
> {
  document = SupportThreadsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDisplayNameDocument = gql`
  query getDisplayName($userId: ID!) {
    getDisplayNameForUserId(userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDisplayNameGQL extends Apollo.Query<
  GetDisplayNameQuery,
  GetDisplayNameQueryVariables
> {
  document = GetDisplayNameDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportThreadDetailsDocument = gql`
  query getSupportThreadDetails($supportThreadId: ID!) {
    getSupportThreadIdDetails(supportThreadId: $supportThreadId) {
      ...SupportThreadDetails
    }
  }
  ${SupportThreadDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportThreadDetailsGQL extends Apollo.Query<
  GetSupportThreadDetailsQuery,
  GetSupportThreadDetailsQueryVariables
> {
  document = GetSupportThreadDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssuesDocument = gql`
  query getSupportIssues(
    $sourceSupportThreadId: ID
    $organizationId: ID
    $assigneeUserId: ID
    $status: [SupportIssueStatus!]
  ) {
    getSupportIssues(
      sourceSupportThreadId: $sourceSupportThreadId
      organizationId: $organizationId
      assigneeUserId: $assigneeUserId
      status: $status
    ) {
      ...SupportIssueThreadListItem
    }
  }
  ${SupportIssueThreadListItemFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssuesGQL extends Apollo.Query<
  GetSupportIssuesQuery,
  GetSupportIssuesQueryVariables
> {
  document = GetSupportIssuesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssuesPageDocument = gql`
  query getSupportIssuesPage(
    $filter: SupportIssueFilterInput
    $offset: Int = 0
    $limit: Int = 50
  ) {
    getSupportIssuesPage(filter: $filter, offset: $offset, limit: $limit) {
      items {
        ...SupportIssueBoardListItem
      }
      totalCount
      offset
      limit
      hasMore
    }
  }
  ${SupportIssueBoardListItemFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssuesPageGQL extends Apollo.Query<
  GetSupportIssuesPageQuery,
  GetSupportIssuesPageQueryVariables
> {
  document = GetSupportIssuesPageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssueQueueSummaryDocument = gql`
  query getSupportIssueQueueSummary($filter: SupportIssueFilterInput) {
    getSupportIssueQueueSummary(filter: $filter) {
      total
      unassigned
      overdue
      dueToday
      due7d
      urgentCount
      noDeadlineCount
      countsByStatus {
        status
        count
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssueQueueSummaryGQL extends Apollo.Query<
  GetSupportIssueQueueSummaryQuery,
  GetSupportIssueQueueSummaryQueryVariables
> {
  document = GetSupportIssueQueueSummaryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssueTimelineDocument = gql`
  query getSupportIssueTimeline(
    $issueId: ID!
    $offset: Int = 0
    $limit: Int = 50
  ) {
    getSupportIssueTimeline(issueId: $issueId, offset: $offset, limit: $limit) {
      items {
        eventId
        actorUserId
        eventType
        issueVersion
        occurredAt
        changes {
          field
          previousValue
          nextValue
        }
      }
      totalCount
      offset
      limit
      hasMore
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssueTimelineGQL extends Apollo.Query<
  GetSupportIssueTimelineQuery,
  GetSupportIssueTimelineQueryVariables
> {
  document = GetSupportIssueTimelineDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MySupportIssueNotificationsDocument = gql`
  query mySupportIssueNotifications(
    $offset: Int = 0
    $limit: Int = 50
    $unreadOnly: Boolean = false
  ) {
    mySupportIssueNotifications(
      offset: $offset
      limit: $limit
      unreadOnly: $unreadOnly
    ) {
      items {
        ...SupportIssueNotificationFields
      }
      totalCount
      unreadCount
      offset
      limit
      hasMore
    }
  }
  ${SupportIssueNotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MySupportIssueNotificationsGQL extends Apollo.Query<
  MySupportIssueNotificationsQuery,
  MySupportIssueNotificationsQueryVariables
> {
  document = MySupportIssueNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkSupportIssueNotificationReadDocument = gql`
  mutation markSupportIssueNotificationRead($notificationId: ID!) {
    markSupportIssueNotificationRead(notificationId: $notificationId) {
      ...SupportIssueNotificationFields
    }
  }
  ${SupportIssueNotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class MarkSupportIssueNotificationReadGQL extends Apollo.Mutation<
  MarkSupportIssueNotificationReadMutation,
  MarkSupportIssueNotificationReadMutationVariables
> {
  document = MarkSupportIssueNotificationReadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkAllSupportIssueNotificationsReadDocument = gql`
  mutation markAllSupportIssueNotificationsRead {
    markAllSupportIssueNotificationsRead
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MarkAllSupportIssueNotificationsReadGQL extends Apollo.Mutation<
  MarkAllSupportIssueNotificationsReadMutation,
  MarkAllSupportIssueNotificationsReadMutationVariables
> {
  document = MarkAllSupportIssueNotificationsReadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WatchSupportIssueNotificationDocument = gql`
  subscription watchSupportIssueNotification {
    supportIssueNotificationCreated {
      ...SupportIssueNotificationFields
    }
  }
  ${SupportIssueNotificationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class WatchSupportIssueNotificationGQL extends Apollo.Subscription<
  WatchSupportIssueNotificationSubscription,
  WatchSupportIssueNotificationSubscriptionVariables
> {
  document = WatchSupportIssueNotificationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssueDocument = gql`
  query getSupportIssue($issueId: ID!) {
    getSupportIssue(issueId: $issueId) {
      ...SupportIssueDetails
    }
  }
  ${SupportIssueDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssueGQL extends Apollo.Query<
  GetSupportIssueQuery,
  GetSupportIssueQueryVariables
> {
  document = GetSupportIssueDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssueAssigneesDocument = gql`
  query getSupportIssueAssignees($supportTeamId: ID) {
    getSupportIssueAssignees(supportTeamId: $supportTeamId) {
      userId
      displayName
      login
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssueAssigneesGQL extends Apollo.Query<
  GetSupportIssueAssigneesQuery,
  GetSupportIssueAssigneesQueryVariables
> {
  document = GetSupportIssueAssigneesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportIssueTagsDocument = gql`
  query getSupportIssueTags($query: String, $limit: Int, $supportTeamId: ID) {
    getSupportIssueTags(
      query: $query
      limit: $limit
      supportTeamId: $supportTeamId
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportIssueTagsGQL extends Apollo.Query<
  GetSupportIssueTagsQuery,
  GetSupportIssueTagsQueryVariables
> {
  document = GetSupportIssueTagsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportThreadAiSuggestionsDocument = gql`
  query getSupportThreadAiSuggestions($supportThreadId: ID!) {
    getSupportThreadAiSuggestions(supportThreadId: $supportThreadId) {
      ...SupportThreadAiSuggestionFields
    }
  }
  ${SupportThreadAiSuggestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportThreadAiSuggestionsGQL extends Apollo.Query<
  GetSupportThreadAiSuggestionsQuery,
  GetSupportThreadAiSuggestionsQueryVariables
> {
  document = GetSupportThreadAiSuggestionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportThreadAiAnalysisStatusDocument = gql`
  query getSupportThreadAiAnalysisStatus($supportThreadId: ID!) {
    getSupportThreadAiAnalysisStatus(supportThreadId: $supportThreadId) {
      ...SupportThreadAiAnalysisStatusFields
    }
  }
  ${SupportThreadAiAnalysisStatusFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportThreadAiAnalysisStatusGQL extends Apollo.Query<
  GetSupportThreadAiAnalysisStatusQuery,
  GetSupportThreadAiAnalysisStatusQueryVariables
> {
  document = GetSupportThreadAiAnalysisStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetChatMessagesForSupportDocument = gql`
  query getChatMessagesForSupport(
    $offset: Int
    $limit: Int
    $conversationId: ID!
  ) {
    getSupportChatMessages(
      conversationId: $conversationId
      offset: $offset
      limit: $limit
    ) {
      authorId
      comment
      date
      type
      standaloneSupportMessageId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetChatMessagesForSupportGQL extends Apollo.Query<
  GetChatMessagesForSupportQuery,
  GetChatMessagesForSupportQueryVariables
> {
  document = GetChatMessagesForSupportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertSupportMessageDocument = gql`
  mutation insertSupportMessage(
    $message: String!
    $type: CommnetType!
    $standaloneSupportMessageId: ID!
    $conversationId: ID!
  ) {
    insertMessageFromSupport(
      message: $message
      type: $type
      messageId: $standaloneSupportMessageId
      conversationId: $conversationId
    ) {
      authorId
      comment
      date
      standaloneSupportMessageId
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertSupportMessageGQL extends Apollo.Mutation<
  InsertSupportMessageMutation,
  InsertSupportMessageMutationVariables
> {
  document = InsertSupportMessageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNewMessagesDocument = gql`
  subscription getNewMessages($supportThreadId: ID!) {
    messageToSupportSent(supportThreadId: $supportThreadId) {
      authorId
      comment
      date
      standaloneSupportMessageId
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetNewMessagesGQL extends Apollo.Subscription<
  GetNewMessagesSubscription,
  GetNewMessagesSubscriptionVariables
> {
  document = GetNewMessagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SupportThreadUpdatedDocument = gql`
  subscription supportThreadUpdated($supportTeamId: ID!) {
    supportThreadUpdated(supportTeamId: $supportTeamId) {
      ...SupportThreadDetails
    }
  }
  ${SupportThreadDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SupportThreadUpdatedGQL extends Apollo.Subscription<
  SupportThreadUpdatedSubscription,
  SupportThreadUpdatedSubscriptionVariables
> {
  document = SupportThreadUpdatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSupportThreadDocument = gql`
  mutation updateSupportThread(
    $supportThreadId: ID!
    $input: ThreadUpdateInput!
  ) {
    updateThread(
      supportThreadId: $supportThreadId
      threadUpdateDetails: $input
    ) {
      ...SupportThreadDetails
    }
  }
  ${SupportThreadDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSupportThreadGQL extends Apollo.Mutation<
  UpdateSupportThreadMutation,
  UpdateSupportThreadMutationVariables
> {
  document = UpdateSupportThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSupportIssueFromThreadDocument = gql`
  mutation createSupportIssueFromThread(
    $supportThreadId: ID!
    $input: CreateSupportIssueFromThreadInput!
  ) {
    createSupportIssueFromSupportThread(
      supportThreadId: $supportThreadId
      input: $input
    ) {
      ...SupportIssueDetails
    }
  }
  ${SupportIssueDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateSupportIssueFromThreadGQL extends Apollo.Mutation<
  CreateSupportIssueFromThreadMutation,
  CreateSupportIssueFromThreadMutationVariables
> {
  document = CreateSupportIssueFromThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSupportIssueDocument = gql`
  mutation createSupportIssue($input: CreateSupportIssueInput!) {
    createSupportIssue(input: $input) {
      ...SupportIssueDetails
    }
  }
  ${SupportIssueDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateSupportIssueGQL extends Apollo.Mutation<
  CreateSupportIssueMutation,
  CreateSupportIssueMutationVariables
> {
  document = CreateSupportIssueDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSupportIssueDocument = gql`
  mutation updateSupportIssue($issueId: ID!, $input: UpdateSupportIssueInput!) {
    updateSupportIssue(issueId: $issueId, input: $input) {
      ...SupportIssueDetails
    }
  }
  ${SupportIssueDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSupportIssueGQL extends Apollo.Mutation<
  UpdateSupportIssueMutation,
  UpdateSupportIssueMutationVariables
> {
  document = UpdateSupportIssueDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateSupportThreadAiSuggestionsDocument = gql`
  mutation generateSupportThreadAiSuggestions($supportThreadId: ID!) {
    generateSupportThreadAiSuggestions(supportThreadId: $supportThreadId) {
      ...SupportThreadAiAnalysisStatusFields
    }
  }
  ${SupportThreadAiAnalysisStatusFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateSupportThreadAiSuggestionsGQL extends Apollo.Mutation<
  GenerateSupportThreadAiSuggestionsMutation,
  GenerateSupportThreadAiSuggestionsMutationVariables
> {
  document = GenerateSupportThreadAiSuggestionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WatchSupportThreadAiAnalysisStatusDocument = gql`
  subscription watchSupportThreadAiAnalysisStatus($supportThreadId: ID!) {
    supportThreadAiAnalysisStatusUpdated(supportThreadId: $supportThreadId) {
      ...SupportThreadAiAnalysisStatusFields
    }
  }
  ${SupportThreadAiAnalysisStatusFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class WatchSupportThreadAiAnalysisStatusGQL extends Apollo.Subscription<
  WatchSupportThreadAiAnalysisStatusSubscription,
  WatchSupportThreadAiAnalysisStatusSubscriptionVariables
> {
  document = WatchSupportThreadAiAnalysisStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetSupportThreadAiSuggestionRatingDocument = gql`
  mutation setSupportThreadAiSuggestionRating(
    $supportThreadAiSuggestionId: ID!
    $rating: Int!
  ) {
    setSupportThreadAiSuggestionRating(
      supportThreadAiSuggestionId: $supportThreadAiSuggestionId
      rating: $rating
    ) {
      ...SupportThreadAiSuggestionFields
    }
  }
  ${SupportThreadAiSuggestionFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SetSupportThreadAiSuggestionRatingGQL extends Apollo.Mutation<
  SetSupportThreadAiSuggestionRatingMutation,
  SetSupportThreadAiSuggestionRatingMutationVariables
> {
  document = SetSupportThreadAiSuggestionRatingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MineDetailsDocument = gql`
  query mineDetails {
    getMe {
      supportTeamMemberId
      teamMemberId
      supportTeamId
      activeSupportTeams {
        supportTeamId
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineDetailsGQL extends Apollo.Query<
  MineDetailsQuery,
  MineDetailsQueryVariables
> {
  document = MineDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WatchForThreadUpdatedDocument = gql`
  subscription watchForThreadUpdated($supportTeamId: ID!) {
    supportThreadUpdated(supportTeamId: $supportTeamId) {
      ...SupportThreadDetails
    }
  }
  ${SupportThreadDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class WatchForThreadUpdatedGQL extends Apollo.Subscription<
  WatchForThreadUpdatedSubscription,
  WatchForThreadUpdatedSubscriptionVariables
> {
  document = WatchForThreadUpdatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WatchForNewSupportThreadsDocument = gql`
  subscription watchForNewSupportThreads($supportTeamId: ID!) {
    supportThreadCreatedByUser(supportTeamId: $supportTeamId) {
      ...SupportThreadDetails
    }
  }
  ${SupportThreadDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class WatchForNewSupportThreadsGQL extends Apollo.Subscription<
  WatchForNewSupportThreadsSubscription,
  WatchForNewSupportThreadsSubscriptionVariables
> {
  document = WatchForNewSupportThreadsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginAsDocument = gql`
  mutation loginAs($userId: ID, $type: UserType) {
    createAutoLogin(type: $type, userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginAsGQL extends Apollo.Mutation<
  LoginAsMutation,
  LoginAsMutationVariables
> {
  document = LoginAsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNamesForAllSupportedClientsDocument = gql`
  query getNamesForAllSupportedClients {
    getNamesForAllSupportedClients {
      email
      name
      organizationName
      organizationId
      phone
      supportedClientIdentifierId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetNamesForAllSupportedClientsGQL extends Apollo.Query<
  GetNamesForAllSupportedClientsQuery,
  GetNamesForAllSupportedClientsQueryVariables
> {
  document = GetNamesForAllSupportedClientsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLastSeenForUserDocument = gql`
  query getLastSeenForUser($userId: ID!, $organizationId: ID!) {
    getLastSeen(userId: $userId, organizationId: $organizationId) {
      id
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLastSeenForUserGQL extends Apollo.Query<
  GetLastSeenForUserQuery,
  GetLastSeenForUserQueryVariables
> {
  document = GetLastSeenForUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindOldUserDocument = gql`
  query findOldUser($query: String) {
    findOldZalamoUser(query: $query) {
      type
      userId
      name
      login
      phone
      lastSeen
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FindOldUserGQL extends Apollo.Query<
  FindOldUserQuery,
  FindOldUserQueryVariables
> {
  document = FindOldUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOldUserDetailsDocument = gql`
  query getOldUserDetails($userId: String) {
    getOldUserDetails(userId: $userId) {
      clientSessionsCount
      oldUserDetailsId
      verifiedPhone
      photographerAlbumDesignCount
      photographerBookingsCount
      photographerGalleryCount
      photographerPrivateSessionsCount
      photographerPublicSessionsCount
      photographerWeddingCount
      type
      sessions {
        name
        oldSessionDetailsId
        created
        photographer {
          login
          name
          phone
          userId
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetOldUserDetailsGQL extends Apollo.Query<
  GetOldUserDetailsQuery,
  GetOldUserDetailsQueryVariables
> {
  document = GetOldUserDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MakrPhoneNumberAsVerifiedDocument = gql`
  mutation makrPhoneNumberAsVerified($userId: ID!) {
    makrPhoneNumberAsVerified(userId: $userId) {
      oldUserDetailsId
      verifiedPhone
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MakrPhoneNumberAsVerifiedGQL extends Apollo.Mutation<
  MakrPhoneNumberAsVerifiedMutation,
  MakrPhoneNumberAsVerifiedMutationVariables
> {
  document = MakrPhoneNumberAsVerifiedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetZalamoStatsDocument = gql`
  query getZalamoStats {
    newZalamoStats {
      imagesPerformance {
        avg
        count
        p25
        p50
        p75
        p90
        p100
        time
      }
      zalamoPay {
        errors
        todayCount
      }
      frames {
        enabled {
          context
          count
          organizationName
        }
      }
      orders {
        days {
          orders
          date
          revenue
          currency
          orgCount
          context
        }
        months {
          revenue
          date
          orders
          currency
          orgCount
          context
        }
        topOrgsDaily {
          revenue
          name
          ordersCount
        }
        topOrgsWeekly {
          revenue
          name
          ordersCount
        }
        topOrgsMonthly {
          revenue
          name
          ordersCount
        }
        topOrgsYearly {
          revenue
          name
          ordersCount
        }
        framesLastWeek {
          context
          currency
          date
          orders
          orgCount
          revenue
          productCount
        }
        wallDecor {
          context
          currency
          date
          orders
          orgCount
          revenue
          productCount
        }
      }
      usage {
        publicSessions {
          orgCount
          count
          month
        }
        privateSessions {
          orgCount
          count
          month
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetZalamoStatsGQL extends Apollo.Query<
  GetZalamoStatsQuery,
  GetZalamoStatsQueryVariables
> {
  document = GetZalamoStatsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPrivateSessionClientUserIdDocument = gql`
  query getPrivateSessionClientUserId($privateSessionId: ID!) {
    getPrivateSessionClientUserId(privateSessionId: $privateSessionId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPrivateSessionClientUserIdGQL extends Apollo.Query<
  GetPrivateSessionClientUserIdQuery,
  GetPrivateSessionClientUserIdQueryVariables
> {
  document = GetPrivateSessionClientUserIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RestoreArchiveDocument = gql`
  mutation restoreArchive($subject: String) {
    restoreArchive(subject: $subject)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RestoreArchiveGQL extends Apollo.Mutation<
  RestoreArchiveMutation,
  RestoreArchiveMutationVariables
> {
  document = RestoreArchiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSchoolDetailsDocument = gql`
  query getSchoolDetails($schoolId: ID!) {
    getSchoolDetails(schoolId: $schoolId) {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSchoolDetailsGQL extends Apollo.Query<
  GetSchoolDetailsQuery,
  GetSchoolDetailsQueryVariables
> {
  document = GetSchoolDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSchoolDetailsDocument = gql`
  mutation updateSchoolDetails($schoolId: ID!, $input: SchoolDetailsInput) {
    updateSchoolDetails(schoolId: $schoolId, schoolDetails: $input) {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSchoolDetailsGQL extends Apollo.Mutation<
  UpdateSchoolDetailsMutation,
  UpdateSchoolDetailsMutationVariables
> {
  document = UpdateSchoolDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendMailToSchoolDocument = gql`
  mutation sendMailToSchool($schoolId: ID!) {
    sendMailToSchool(schoolId: $schoolId) {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SendMailToSchoolGQL extends Apollo.Mutation<
  SendMailToSchoolMutation,
  SendMailToSchoolMutationVariables
> {
  document = SendMailToSchoolDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ShowEnabledPaymentMethodsDocument = gql`
  query showEnabledPaymentMethods($userId: Int!) {
    showEnabledPaymentMethods(userId: $userId) {
      paymentMethodId
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ShowEnabledPaymentMethodsGQL extends Apollo.Query<
  ShowEnabledPaymentMethodsQuery,
  ShowEnabledPaymentMethodsQueryVariables
> {
  document = ShowEnabledPaymentMethodsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeletePaymentMethodDocument = gql`
  mutation deletePaymentMethod($paymentMethodId: ID!, $userId: Int!) {
    deletePaymentMethod(paymentMethodId: $paymentMethodId, userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeletePaymentMethodGQL extends Apollo.Mutation<
  DeletePaymentMethodMutation,
  DeletePaymentMethodMutationVariables
> {
  document = DeletePaymentMethodDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangePhotographerSubdomainDocument = gql`
  mutation changePhotographerSubdomain(
    $subdomain: String!
    $newSubdomain: String!
  ) {
    changePhotographerSubdomain(
      subdomain: $subdomain
      newSubdomain: $newSubdomain
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ChangePhotographerSubdomainGQL extends Apollo.Mutation<
  ChangePhotographerSubdomainMutation,
  ChangePhotographerSubdomainMutationVariables
> {
  document = ChangePhotographerSubdomainDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePublicSessionProlongationDocument = gql`
  mutation updatePublicSessionProlongation(
    $publicSessionId: ID!
    $prolongation: Int!
  ) {
    updatePublicSessionProlongation(
      publicSessionId: $publicSessionId
      prolongation: $prolongation
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdatePublicSessionProlongationGQL extends Apollo.Mutation<
  UpdatePublicSessionProlongationMutation,
  UpdatePublicSessionProlongationMutationVariables
> {
  document = UpdatePublicSessionProlongationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindSessionUserIdByHashDocument = gql`
  query findSessionUserIdByHash($hash: String!) {
    findSessionUserIdByHash(hash: $hash) {
      userId
      organizationId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FindSessionUserIdByHashGQL extends Apollo.Query<
  FindSessionUserIdByHashQuery,
  FindSessionUserIdByHashQueryVariables
> {
  document = FindSessionUserIdByHashDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportUserTestsDocument = gql`
  query getSupportUserTests($userId: ID!) {
    getSupportUserTests(userId: $userId) {
      userId
      availableTests
      activeTests
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportUserTestsGQL extends Apollo.Query<
  GetSupportUserTestsQuery,
  GetSupportUserTestsQueryVariables
> {
  document = GetSupportUserTestsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSupportUserTestsDocument = gql`
  mutation updateSupportUserTests($userId: ID!, $tests: [UserTest!]!) {
    updateSupportUserTests(userId: $userId, tests: $tests) {
      userId
      availableTests
      activeTests
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSupportUserTestsGQL extends Apollo.Mutation<
  UpdateSupportUserTestsMutation,
  UpdateSupportUserTestsMutationVariables
> {
  document = UpdateSupportUserTestsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ClearSupportUserTestsCacheDocument = gql`
  mutation clearSupportUserTestsCache($userId: ID!) {
    clearSupportUserTestsCache(userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClearSupportUserTestsCacheGQL extends Apollo.Mutation<
  ClearSupportUserTestsCacheMutation,
  ClearSupportUserTestsCacheMutationVariables
> {
  document = ClearSupportUserTestsCacheDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportOrganizationTestsDocument = gql`
  query getSupportOrganizationTests($organizationId: ID!) {
    getSupportOrganizationTests(organizationId: $organizationId) {
      organizationId
      availableTests
      activeTests
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportOrganizationTestsGQL extends Apollo.Query<
  GetSupportOrganizationTestsQuery,
  GetSupportOrganizationTestsQueryVariables
> {
  document = GetSupportOrganizationTestsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSupportOrganizationTestsDocument = gql`
  mutation updateSupportOrganizationTests(
    $organizationId: ID!
    $tests: [OrganizationTest!]!
  ) {
    updateSupportOrganizationTests(
      organizationId: $organizationId
      tests: $tests
    ) {
      organizationId
      availableTests
      activeTests
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSupportOrganizationTestsGQL extends Apollo.Mutation<
  UpdateSupportOrganizationTestsMutation,
  UpdateSupportOrganizationTestsMutationVariables
> {
  document = UpdateSupportOrganizationTestsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTextSnippetsDocument = gql`
  query getTextSnippets {
    getTextSnippets {
      ...TextSnippetDetails
    }
  }
  ${TextSnippetDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTextSnippetsGQL extends Apollo.Query<
  GetTextSnippetsQuery,
  GetTextSnippetsQueryVariables
> {
  document = GetTextSnippetsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTextSnippetDocument = gql`
  mutation createTextSnippet(
    $supportSnippetId: ID!
    $title: String!
    $content: [I18nTextInput!]!
  ) {
    createTextSnippet(
      supportSnippetId: $supportSnippetId
      title: $title
      content: $content
    ) {
      ...TextSnippetDetails
    }
  }
  ${TextSnippetDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTextSnippetGQL extends Apollo.Mutation<
  CreateTextSnippetMutation,
  CreateTextSnippetMutationVariables
> {
  document = CreateTextSnippetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTextSnippetDocument = gql`
  mutation updateTextSnippet(
    $supportSnippetId: ID!
    $title: String!
    $content: [I18nTextInput!]!
  ) {
    updateTextSnippet(
      supportSnippetId: $supportSnippetId
      title: $title
      content: $content
    ) {
      ...TextSnippetDetails
    }
  }
  ${TextSnippetDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTextSnippetGQL extends Apollo.Mutation<
  UpdateTextSnippetMutation,
  UpdateTextSnippetMutationVariables
> {
  document = UpdateTextSnippetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTextSnippetDocument = gql`
  mutation deleteTextSnippet($supportSnippetId: ID!) {
    deleteTextSnippet(supportSnippetId: $supportSnippetId) {
      supportSnippetId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTextSnippetGQL extends Apollo.Mutation<
  DeleteTextSnippetMutation,
  DeleteTextSnippetMutationVariables
> {
  document = DeleteTextSnippetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
